import {
  withFormsy,
} from 'formsy-react';
import {
  withTranslation,
} from 'react-i18next';

import InputFileView from './InputFileView';
import './InputFile.css';

// @ts-expect-error form component
const InputComponent = withFormsy(InputFileView);

const TranslatedComponent = withTranslation()(InputComponent);

const Component = TranslatedComponent;

export default Component;
